import { trigger, style, transition, animate } from '@angular/animations';

export const slideInOut = [
    trigger('slideInOut', [
        transition(':enter', [
            style({ transform: 'translateX(100%)' }),
            animate('500ms ease-in', style({ transform: 'translateX(0%)' }))
        ]),
        transition(':leave', [
            style({ transform: 'translateX(0%)' }),
            animate('500ms ease-in', style({ transform: 'translateX(100%)' }))
        ])
    ])
];

export const fadeInOut = [
    trigger('fadeInOut', [
        transition(':enter', [
            style({ opacity: '0' }),
            animate('.6s ease-out', style({ opacity: '1' }))
        ]),
        transition(':leave', [
            style({ opacity: '1' }),
            animate('.6s ease-out', style({ opacity: '0' }))
        ])
    ])
];